import ArrowImg from 'assets/images/settings/right-arrow.svg'
import CheckIcon from 'components/Icons/CheckIcon'
import palette from 'components/palette'
import { Node } from 'data/types'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { color } from 'utils'

const DropDownContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
`

const DropDownHeader = styled.div`
  padding: 1.25rem 1.5rem;
  font-weight: 600;
  color: ${color('white')};
  background: ${color('dark900')};
  border: 1px solid ${color('dark700')};
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease-in;
  cursor: pointer;
`

const DropDownList = styled.ul`
  z-index: 3;
  width: 100%;
  padding: 0;
  margin: 0.5rem 0 0 0;
  background: ${color('dark900')};
  border-radius: 8px;
  box-sizing: border-box;
  color: ${color('white')};
  font-weight: 500;
  display: grid;
  grid-auto-rows: min-content;
  max-height: 30rem;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`

const ListItem = styled.li<{ selected?: boolean }>`
  list-style: none;
  font-weight: 600;
  padding: 1.125rem 1.5rem;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease-in;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:first-child {
    border-radius: 5px 5px 0 0;
  }
  &:last-child {
    border-radius: 0px 0px 5px 5px;
  }

  &:hover {
    background: ${color('dark700')};
  }
`

const ListTitle = styled.p`
  margin: 0;
`

const ArrowIcon = styled.img`
  transform: rotate(90deg);
  height: 0.625rem;
`

type DropdownTypes = {
  onChange: (option: Node) => void
  options: Array<Node>
}

const getChecked = (options: Array<Node>) =>
  options.find((option) => option.type === 'SELECTION' && option.checked === true)

const Dropdown = ({ onChange, options }: DropdownTypes) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(false)

    if (options.length === 0) return

    if (!getChecked(options)) {
      onChange({ ...options[0], checked: true } as Node)
    }
  }, [options.length])

  const selectedOption = getChecked(options)

  return (
    <DropDownContainer>
      <DropDownHeader onClick={() => setIsOpen(true)}>
        <ListTitle>{selectedOption?.text ?? options[0].text}</ListTitle>
        <ArrowIcon src={ArrowImg} />
      </DropDownHeader>

      {isOpen && (
        <div>
          <DropDownList>
            {options.map((option) => {
              if (option.type !== 'SELECTION') return null
              return (
                <ListItem
                  key={option.id}
                  onClick={() => {
                    onChange({ ...option, checked: !option.checked })
                    setIsOpen(false)
                  }}
                  selected={option.id === selectedOption?.id}
                >
                  <ListTitle>{option.text}</ListTitle>
                  {option.id === selectedOption?.id && <CheckIcon color={palette.blue400} />}
                </ListItem>
              )
            })}
          </DropDownList>
        </div>
      )}
    </DropDownContainer>
  )
}

export default Dropdown
